import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { AvatarList, AvatarListItemRoot, Icon } from '@a-type/ui';
import { withGame } from '@long-game/game-client';
import { PlayerAvatar } from './PlayerAvatar.js';
import cls from './PlayerStatuses.module.css';
export const PlayerStatuses = withGame(function PlayerStatuses({ gameSuite, className, style, ...rest }) {
    const memberStatusList = gameSuite.members.map((member) => {
        return {
            player: gameSuite.players[member.id] ?? {
                id: member.id,
                name: 'Loading...',
                color: 'gray',
            },
            status: gameSuite.playerStatuses[member.id] ?? {
                online: false,
                pendingTurn: false,
            },
            hasPlayed: gameSuite.gameStatus.status !== 'pending' &&
                !!gameSuite.viewingRound?.turns.some((turn) => turn.playerId === member.id),
        };
    });
    return (_jsx(AvatarList, { count: memberStatusList.length, className: className, style: { flexShrink: 0, ...style }, ...rest, children: memberStatusList
            .sort((a, b) => a.status.pendingTurn && !b.status.pendingTurn
            ? 1
            : b.status.pendingTurn && !a.status.pendingTurn
                ? -1
                : 0)
            .map(({ status, player, hasPlayed }, index) => (_jsx(AvatarListItemRoot, { index: index, style: {
                opacity: !hasPlayed && !status?.pendingTurn ? 0.5 : 1,
            }, children: _jsx(PlayerStatusAvatar, { player: player, status: status, hasPlayed: hasPlayed }) }, player.id))) }));
});
function PlayerStatusAvatar({ player, status, hasPlayed, }) {
    return (_jsxs("div", { style: { position: 'relative', overflow: 'visible' }, children: [_jsx(PlayerAvatar, { playerId: player.id, interactive: true }), hasPlayed || status?.pendingTurn ? (_jsx("div", { className: cls.statusIcon, "data-has-played": hasPlayed, children: _jsx(Icon, { name: hasPlayed ? 'check' : 'clock', size: 10 }) })) : null] }));
}
//# sourceMappingURL=PlayerStatuses.js.map